<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardBody>
      <CRow>
        <FilterPembayaranKeanggotaan/>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-6">
          <div class="form-group">
            <CSelect
              class="float-left"
              label="Data Per Halaman"
              placeholder="Data Per Halaman"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>

        <div class="col-sm-12 col-xl-4 ml-auto">
          <div class="form-group">
            <CInput
              class="float-right"
              label="Pencarian"
              placeholder="Cari Data .."
              v-model="searchPembayaran"
            />
          </div>
        </div>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ indexed == 0 ? index +  1 : index + indexed + 1 }}</td>
            </template>
            <template #nominal="{item}">
              <td class="py-2">{{ 'Rp.'+item.nominal }}</td>
            </template>
            <template #status_pembayaran="{item}">
              <td class="py-2 font-weight-bold text-success" v-if="item.status_pembayaran == 'settlement'">Lunas</td>              
              <td class="py-2 font-weight-bold text-warning" v-else-if="item.status_pembayaran == 'pending'">Menunggu Pembayaran</td>              
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == 'expire'">Expired</td>              
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == 'failure'">Pembayaran Gagal</td>
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == null">Dibatalkan</td>
              <td class="py-2 font-weight-bold text-danger"  v-else>Gagal</td>
            </template>
           <template #aksi="{item}">
              <td class="py-2 d-flex align-items-center">
                <CButton
                  color="warning"
                  class="btn-sm text-white"
                  square
                  @click="$router.push('/keuangan/pembayaran/detail-invoice/'+item.id_invoice)">
                <font-awesome-icon icon="coins" /> 
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPagePembayaran"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import PaymentService from '@/services/finance/payment.service'
import FilterPembayaranKeanggotaan from '@/components/finance/permintaan-pembatalan/FilterPembayaranKeanggotaan'
import { Pagination } from "@/mixins/Pagination";
import { AlertUtils } from "@/mixins/AlertUtils";
import { exportUtils } from '@/mixins/exportUtils';
const fields = [
  {
    key: "no",
    label: "No",
    sorter: false,
    filter: false
  },
  {
    key: "id_invoice",
    label: "Kode Pembayaran",
    sorter: false,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: false,
    filter: false
  },
  {
    key: "email",
    label: "Email",
    sorter: false,
    filter: false
  },
  {
    key: "nama_item",
    label: "Jenis Pembayaran",
    sorter: false,
    filter: false
  },
  {
    key: "nominal",
    label: "Nominal",
    sorter: false,
    filter: false
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: false,
    filter: false
  },  
  {
    key: "aksi",
    label: "Aksi",
    sorter: false,
    filter: false
  },
  
];

export default {
  name: "Payment",
  
  mixins: [Pagination, AlertUtils, exportUtils],
  components: {
    FilterPembayaranKeanggotaan
  },
  data() {
    return {
      items: [],
      currentPagePembayaran: 3,
      fields,
      tipe: 'pembayaran_anggota',
      no: 1,
      collapseDuration: 0,
      content: []
    };
  },
  methods: {
    pageChange() {
      this.getData(currenPage);
    },

    changePelatihan(value) {
      this.periode = value.periode;
      this.id = value.id;
      this.getData("0", this.pageSize, this.tipe, this.searchPembayaran, value.periode, value.id);
    },

    download(value) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.periode = value.periode
      this.id = value.id
      PaymentService.download(this.tipe, value.periode, value.id)
      .then(response => {
          loader.hide()
          this.exportData(response.data, 'Data-Pembayaran-Iuran-Anggota');
          this.alertExportSuccess();
        })
      .catch(error => {
        this.alertExportFailed();
        loader.hide()
      })  
    }, 

    getData(currentPage, pageSize, tipe, filter, periode, id) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;

      PaymentService.getData(
        currentPage,
        pageSize,
        tipe,
        filter,
        periode,
        id
      )
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPagePembayaran = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
  }
};
</script>